import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BreadcrumbService } from '../shared/breadcrumb.service';
import { PatientService } from "../../../services/patient.service";
import { MessageService, ConfirmationService, } from "primeng/primeng";
import { name_input, address, city, phoneNumber, zipCode, URLS } from 'src/app/constant/constant';
import { TraceClassDecorator } from '@sentry/angular';
import { DateUtilService, moment_duration } from '../../../utilities/date.util.service';
import { Router } from '@angular/router';
import { ProviderStateService } from 'src/app/services/provider-state.service';

interface ID_Card {
    medicalRecordNumber: string;
    dateOfBirth: string;
    validTill: string;
    name: string;
    acronym: string;
    avatar_url: string;
}

@Component({
    selector: 'app-activated-members',
    templateUrl: './activated-members.component.html',
    styleUrls: ['./activated-members.component.css', '../../../../assets/css/custom-egd.css'],
    providers: [MessageService, ConfirmationService],

})
@TraceClassDecorator()
export class ActivatedMembersComponent implements OnInit {

    constructor(
        private readonly titleService: Title,
        private readonly breadcrumbService: BreadcrumbService,
        private readonly patientService: PatientService,
        private readonly dateUtil: DateUtilService,
        private readonly router: Router,
        private readonly providerstateService: ProviderStateService

    ) {


    }

    readonly name_input: RegExp = name_input;
    readonly address: RegExp = address;
    readonly city_input: RegExp = city;
    readonly phoneNumber: RegExp = phoneNumber;
    readonly zipCode: RegExp = zipCode;
    slug: string = "";

    readonly number: RegExp = /^[0-9]\d{10}/;
    members_list: any = [];
    member_id_card = -1;
    user_guid: string = "";
    process_loading = false;
    is_uk_country: boolean = false;

    id_card: ID_Card = {
        medicalRecordNumber: "",
        dateOfBirth: "",
        validTill: "",
        name: "",
        acronym: "",
        avatar_url: "",
    };

    async ngOnInit() {
        this.slug = this.providerstateService.getProviderSlug();
        if(URLS.IS_UK)
        {
            this.is_uk_country = true;
        }
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: ['/', this.slug, 'patient'] },
            { label: 'Registered Members' },
        ])
        this.user_guid = sessionStorage.getItem('userid')
        this.SetTitle("Dashboard - Patient Dashboard");
        await this.getMemberList();

    }

    SetTitle(title: string) {
        this.titleService.setTitle(title);

    }
    async getMemberList() {
        let temp = [];
        let temp_2 = [];

        await this.patientService.getMember(this.user_guid).toPromise().then(result => {

            if (result.success) {
                for (let i = 0; i < result.data.patient.length; i++) {
                    result.data.patient[i].valid_till_days = this.dateUtil.diff(new Date(), new Date(result.data.patient[i].valid_till), moment_duration.days)
                    temp.push({
                        id: i,
                        patient_guid: result.data.patient[i].patient_guid,
                        label: " " + result.data.patient[i].first_name + " " + (result.data.patient[i].middle_name == null ? '' : result.data.patient[i].middle_name) + " " + result.data.patient[i].last_name + " ",
                        value: result.data.patient[i],
                    });
                }
                temp_2 = result.data.patient;
            }
        });
        this.members_list = temp;
        // this.members_data=temp_2;
        for (let i = 0; i < this.members_list.length; i++) {
            this.members_list[i].label = this.members_list[i].label.toUpperCase();
        }
    }

    editProfile(patient_guid) {
        this.router.navigate(['/' + this.slug + '/patient/edit-data'],
            { queryParams: { patient_guid } }
        );
    }

    displaycard: Boolean = false;
    showcardDialog(patient_guid: string) {
        this.process_loading = true;
        let index = -1;
        for (let i = 0; i < this.members_list.length; i++) {
            if (this.members_list[i].value.patient_guid == patient_guid) {
                this.member_id_card = i;
                index = i;
            }
        }
        if (index != -1) {
            //let dt = new Date(this.members_list[index].value.date_of_birth.replace(/-/g, '/'))
            let date_of_birth = this.dateUtil.dateFormat(this.members_list[index].value.date_of_birth, 'll')

            //let dt1 = new Date((this.members_list[index].value.valid_till.replace(/-/g, '/')));
            let valid_till = this.dateUtil.dateFormat(this.members_list[index].value.valid_till, 'll')

            let full_name = this.members_list[index].label

            let medical_rec_no = this.members_list[index].value.medical_record_number;
            let acronymm = this.members_list[index].value.country.acronym;
            let avatar_url = this.members_list[index].value.avatar_url;

            this.id_card = {
                medicalRecordNumber: medical_rec_no,
                dateOfBirth: date_of_birth,
                validTill: valid_till,
                name: full_name,
                acronym: acronymm,
                avatar_url: avatar_url,
            };
            this.displaycard = true;
        }
        this.process_loading = false;
    }
    close() {
        this.displaycard = false;
        this.member_id_card = -1;
        this.id_card = {
            medicalRecordNumber: "",
            dateOfBirth: "",
            validTill: "",
            name: "",
            acronym: "",
            avatar_url: ""
        };
    }
}

